"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_Messengder__mono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "7D6E85E9-7F5E-4551-A94D-72525A4E452B"), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-201.000000, -460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-White-/-Messengder-/-Medium",
    transform: "translate(201.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger_Logo_White_RGB",
    transform: "translate(2.666667, 2.666667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,0 C5.82159624,0 0,5.50234742 0,12.9336016 C0,16.8209256 1.59356137,20.1797451 4.18779343,22.5003353 C4.40509725,22.6961771 4.53655265,22.9671362 4.5472837,23.2595573 L4.61971831,25.6311201 C4.64386318,26.3876593 5.42454728,26.878605 6.1167002,26.5754527 L8.76190476,25.4084507 C8.98725687,25.3091885 9.23675386,25.2904091 9.47283702,25.3547954 C10.6881288,25.6901408 11.9839034,25.8672032 13.3333333,25.8672032 C20.8450704,25.8672032 26.6666667,20.3648558 26.6666667,12.9336016 C26.6666667,5.50234742 20.8450704,0 13.3333333,0 Z M21.3386989,9.95036888 L17.4218645,16.1636486 C16.7994634,17.1509054 15.4634474,17.3977197 14.5298457,16.6975184 L11.4151576,14.3608317 C11.1281019,14.1462106 10.7364185,14.1488934 10.4520456,14.3635144 L6.24547284,17.5560027 C5.68477532,17.982562 4.94969819,17.3091885 5.32796781,16.713615 L9.24480215,10.5003353 C9.86720322,9.51307847 11.2032193,9.26626425 12.1368209,9.96646546 L15.2515091,12.3031522 C15.5385647,12.5177733 15.9302482,12.5150905 16.2146211,12.3004695 L20.4211938,9.10798122 C20.9818913,8.68142186 21.7169685,9.35479544 21.3386989,9.95036888 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))));
}

var _default = ic_Messengder__mono;
exports.default = _default;